import { iots } from '@code-expert/prelude';
import { end, formatRoute, lit, type, url } from '/imports/modules/Routing';
import { runnerSectionQuery } from '/imports/ui/pages/admin/navigation';

export const adminSlug = 'admin';

const admin = lit(adminSlug);

export const adminRoute = url(admin, end);

export const pageKeys = {
  analytics: null,
  courses: null,
  env: null,
  notifications: null,
  runners: null,
  settings: null,
  users: null,
};

export type Page = keyof typeof pageKeys;
const page = (p: Page) => url(admin, lit(p));

export const AnalyticsSection = iots.keyof({ status: null, usage: null, usageBySemester: null });
export type AnalyticsSection = iots.TypeOf<typeof AnalyticsSection>;
export const adminAnalyticsSectionRoute = url(
  page('analytics'),
  type('section', AnalyticsSection),
  end,
);
export const adminAnalyticsRoute = url(page('analytics'), end);

export const CourseSection = iots.keyof({ overview: null, add: null, backup: null });
export type CourseSection = iots.TypeOf<typeof CourseSection>;
export const adminCoursesRoute = url(page('courses'), type('section', CourseSection), end);

export const adminEnvRoute = url(page('env'), end);
export const adminNotificationsRoute = url(page('notifications'), end);
export const adminRunnersRoute = url(page('runners'), runnerSectionQuery, end);
export const adminSettingsRoute = url(page('settings'), end);

export const UserSection = iots.keyof({
  online: null,
  adminUsers: null,
  blocked: null,
  merge: null,
  archive: null,
});
export type UserSection = iots.TypeOf<typeof UserSection>;
export const adminUsersRoute = url(page('users'), type('section', UserSection), end);

export const adminUsersLink = formatRoute(adminUsersRoute);
export const adminCoursesLink = formatRoute(adminCoursesRoute);
export const adminRunnersLink = formatRoute(adminRunnersRoute);
export const adminNotificationsLink = formatRoute(adminNotificationsRoute);
export const adminSettingsLink = formatRoute(adminSettingsRoute);
export const adminEnvLink = formatRoute(adminEnvRoute);
export const adminAnalyticsLink = formatRoute(adminAnalyticsRoute);
export const adminAnalyticsSectionLink = formatRoute(adminAnalyticsSectionRoute);
